export default "__VITE_ASSET__DR$PDowg__"